// @ts-nocheck
/* eslint-enable */
// Actions
import AreaActions from 'app/shared/flux/actions/AreaActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';

// Misc / Utils
import fetchAreaWrapperController from 'app/shared/wrappers/FetchAreaWrapper/controller';

const loadAreaSeoLinks = (reactContext, { areaResourceId }) => {
  const { store, trace } = reactContext;
  const { pathname } = reactContext.state;
  const seoInfo = fetchAreaWrapperController.getAreaSeoInfo(pathname);
  const searchSlug = seoInfo.searchSlug || 'apartments-for-rent';

  return store
    .dispatch(AreaActions.loadAreaSeoLinks({ resourceId: areaResourceId, searchSlug }))
    .then((response) => {
      trace.finishAsyncSpan({
        marker: 'FetchAreaWrapper#AreaActions#loadAreaSeoLinks',
      });

      return response;
    })
    .catch((error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.areaPage.serverRouteWillMount#loadAreaSeoLinks',
          errorClass: 'areaActions',
        }),
      );
    });
};

export default loadAreaSeoLinks;
